import { render } from "react-dom";
import App from "./App";

document.addEventListener("DOMContentLoaded", () => {
  let nonce = null;
  const app = document.querySelector("#edupix_rootapp") || null;
  if (app) {
    nonce = app.getAttribute("data-nonce") || null;
  }
  render(<App nonce={nonce} />, document.getElementById("edupix_rootapp"));
});
